import { palette } from '@jupiterone/jupiter-web-toolkit';
import { UsageDataMetrics } from '../types';

const colorByUsageMetric = (usageMetric: UsageDataMetrics) => {
  switch (usageMetric) {
    case 'entityCount':
      return palette.quartary.main;
    case 'billableEntityCount':
      return palette.secondary.light;
    case 'relationshipCount':
      return palette.primary.dark;
    default:
      return palette.coolGrey[600];
  }
};

export default colorByUsageMetric;
